import React, { useRef, useState, useCallback, useEffect } from "react";
import { MoveLeft, Calendar } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Dropdown, Button, Spinner, ToastContainer, Toast } from "react-bootstrap";
import addImage from "../../assets/svg/image_upload.svg";
import chevron_down from "../../assets/Vehicles/chevron_down.png";
import DatePicker from "react-datepicker";
import CommonStaticDropdown from "../common/common_static_dropdown";
import CommonDropdown from "../common/common_dropDown";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { X } from "lucide-react"; // Close icon
import ErrorExtractor from "../common/error_extractor";
import DOMPurify from "dompurify";
import { submitVendorAPI, saveAttachmentApi, updateVendorAPI, getVendorEditApi } from "./vendor-api.js";

export const AddVendor = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
  const [isLoader, setIsLoader] = useState(false);
  const [center, setCenter] = useState({
    lat: 13.0843,
    lng: 80.2705,
  });

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: googleMapsApiKey,
  });
  const [marker, setMarker] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};

  useEffect(() => {
    if (id != null) {
      getVendorEdit(id);
    }
  }, [id]);

  const fileInputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [imageRemoved, setImageRemoved] = useState(false);

  const [dragging, setDragging] = useState(false);

  const handleInputFile = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      /* const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl); */
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result;
        setImage(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result;
        setImage(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const typeList = [
    { label: "Mechanic", value: "Mechanic" },
    { label: "Product", value: "Product" },
    { label: "Customer", value: "Customer" },
  ];

  const [vendorId, setVendorId] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [address, setAddress] = useState("");
  const [cityOption, setCityOption] = useState(null);
  const [stateOption, setStateOption] = useState(null);
  const [countryOption, setCountryOption] = useState(null);
  const [zipCode, setZipCode] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [typeOption, setTypeOption] = useState(null);
  const [dueDate, setDueDate] = useState();
  const [description, setDescription] = useState("");

  const handleTypeSelect = (item) => {
    setTypeOption(item);
  };
  const handleSelectCity = (item) => {
    setCityOption(item);
  };

  const handleSelectState = (item) => {
    setStateOption(item);
  };
  const handleSelectCountry = (item) => {
    setCountryOption(item);
  };

  const onMapClick = useCallback((event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setLatitude(lat);
    setLongitude(lng);
    console.log("Clicked at:", lat, lng);
    setMarker({ lat, lng });
    setCenter({ lat, lng });
    /* alert(`Lat: ${lat}, Lng: ${lng}`); */
  }, []);

  const [errorMsg, setErrorMsg] = useState({
    vendor_id: "",
    name: "",
    address: "",
    city_id: "",
    state_id: "",
    country_id: "",
    zipcode: "",
    latitude: "",
    longitude: "",
    phone_no: "",
    email: "",
    type: "",
    due_date: "",
    description: "",
  });

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      const preSanitizeData = {
        vendor_id: vendorId,
        name: vendorName,
        address: address,
        city_id: cityOption != null ? cityOption.value : "",
        state_id: stateOption != null ? stateOption.value : "",
        country_id: countryOption != null ? countryOption.value : "",
        zipcode: zipCode,
        latitude: latitude,
        longitude: longitude,
        phone_no: mobileNumber,
        email: email,
        type: typeOption != null ? typeOption.value : "",
        due_date: dueDate != null && dueDate !== "" ? dueDate.toLocaleDateString("en-CA") : "",
        description: description,
        image_removed: imageRemoved,
        image: image,
        status: true,
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitVendorAPI(sanitizedData);
      } else {
        response = await updateVendorAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            vendor_id: "",
            name: "",
            address: "",
            city_id: "",
            state_id: "",
            country_id: "",
            zipcode: "",
            latitude: "",
            longitude: "",
            phone_no: "",
            email: "",
            type: "",
            due_date: "",
            description: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        console.log("saveAttachment called 0");
        if (image === null) {
          console.log("saveAttachment called 1");
          navigate(-1);
        } else {
          console.log("saveAttachment called 2");
          saveAttachment(response.data.id);
        }
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (err.response && err.response.status === 400 && err.response.data.error) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };
  const saveAttachment = async (parentId) => {
    console.log("saveAttachment called");
    try {
      const data = {
        attachment: image,
      };
      const response = await saveAttachmentApi(parentId, data);
      if (response.data.success === true) {
        navigate(-1);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  };

  const getVendorEdit = async (id) => {
    try {
      const response = await getVendorEditApi(id);

      if (response.data.success === true) {
        const workOrderDetail = response.data.vendor ?? {};

        setVendorId(workOrderDetail.vendor_id ?? "");
        setVendorName(workOrderDetail.name ?? "");
        setAddress(workOrderDetail.address ?? "");
        setCityOption({
          value: workOrderDetail.city_id ?? "",
          label: workOrderDetail.city ?? "",
        });
        setStateOption({
          value: workOrderDetail.state_id ?? "",
          label: workOrderDetail.state ?? "",
        });
        setCountryOption({
          value: workOrderDetail.country_id ?? "",
          label: workOrderDetail.country ?? "",
        });

        setZipCode(workOrderDetail.zipcode);
        setLatitude(workOrderDetail.latitude);
        setLongitude(workOrderDetail.longitude);
        if (workOrderDetail.latitude != null && workOrderDetail.latitude !== "") {
          setMarker({
            lat: Number(workOrderDetail.latitude),
            lng: Number(workOrderDetail.longitude),
          });
          setCenter({
            lat: Number(workOrderDetail.latitude),
            lng: Number(workOrderDetail.longitude),
          });
        }

        setMobileNumber(workOrderDetail.phone_no);
        setEmail(workOrderDetail.email);
        setTypeOption({
          value: workOrderDetail.type ?? "",
          label: workOrderDetail.type ?? "",
        });
        setDueDate(workOrderDetail.due_date != null && workOrderDetail.due_date !== "" ? new Date(workOrderDetail.due_date) : null);
        setDescription(workOrderDetail.description);
        setImageUrl(workOrderDetail.image ?? "");
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  return (
    <div>
      <div className="w-100 bg-half-white">
        <div
          className="d-flex align-items-center justify-content-between bg-white"
          style={{
            paddingLeft: "16px",
            paddingRight: "16px",
            borderTop: "1px solid #EBEBEB",
            borderBottom: "1px solid #EBEBEB",
          }}
        >
          <div className="d-flex gap-3 my-3">
            <MoveLeft className="cursor-pointer" onClick={() => navigate(-1)} />
            <p className="fw-semibold m-0">New vendor</p>
          </div>
          <div className="d-flex gap-3">
            <Button className="bg-white rounded-pill px-4 py-2 pagination-color btn-border-grey" onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button className={`dark-purple-btn ${isLoader ? "disabled-btn" : ""} rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`} onClick={submitForm} style={{ minWidth: "100px" }}>
              {isLoader ? <Spinner animation="border" size="sm" /> : id != null ? "Update" : "Save"}
            </Button>
          </div>
        </div>
        <div className="p-3">
          <div className="bg-white rounded-4 p-3">
            <div className="row p-2">
              <p className="fs-16 fw-600 pagination-color">User image</p>
              <div className="col-12">
                {image ? (
                  <>
                    <div
                      style={{
                        position: "relative",
                        width: "100px",
                        height: "100px",
                      }}
                    >
                      <div
                        onClick={handleInputFile}
                        onDrop={handleDrop}
                        onDragOver={(e) => e.preventDefault()}
                        onDragEnter={() => setDragging(true)}
                        onDragLeave={() => setDragging(false)}
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          objectFit: "cover",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={image}
                          className="rounded-circle"
                          alt="Uploaded Vehicle"
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                      <button
                        onClick={(e) => {
                          setImage(null);
                        }}
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          background: "white",
                          border: "none",
                          borderRadius: "50%",
                          cursor: "pointer",
                          padding: "4px",
                        }}
                      >
                        <X size={16} color="#ff0000" />
                      </button>
                    </div>
                  </>
                ) : imageUrl !== "" ? (
                  <>
                    <div
                      style={{
                        position: "relative",
                        width: "100px",
                        height: "100px",
                      }}
                    >
                      <div
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          objectFit: "cover",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={imageUrl}
                          className="rounded-circle"
                          alt="Uploaded Vehicle"
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                      <button
                        onClick={(e) => {
                          setImageUrl("");
                          setImageRemoved(true);
                        }}
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          background: "white",
                          border: "none",
                          borderRadius: "50%",
                          cursor: "pointer",
                          padding: "4px",
                        }}
                      >
                        <X size={16} color="#ff0000" />
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      onClick={handleInputFile}
                      onDrop={handleDrop}
                      onDragOver={(e) => e.preventDefault()}
                      onDragEnter={() => setDragging(true)}
                      onDragLeave={() => setDragging(false)}
                      style={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={addImage}
                        alt="Uploaded Vehicle"
                        style={{
                          width: "80px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </>
                )}

                <input type="file" accept="image/*" ref={fileInputRef} className="d-none" onChange={handleFileChange} />
              </div>

              <p style={{ color: "#172B4D" }} className="fs-16 fw-600 mt-3">
                User information
              </p>
              <div className="col-xl-4">
                <label htmlFor="fill" className="form-label  fw-400 d-flex">
                  Vendor ID<span className="error-text">*</span>
                </label>
                <input type="text" className="form-control rounded-3 vehicle-form-input" id="fill" placeholder="Enter here..." value={vendorId} onChange={(e) => setVendorId(e.target.value)} />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.vendor_id}
                </span>
              </div>
              <div className="col-xl-4">
                <label htmlFor="fill" className="form-label  fw-400 d-flex">
                  Vendor Name<span className="error-text">*</span>
                </label>
                <input type="text" className="form-control rounded-3 vehicle-form-input" id="fill" placeholder="Enter here..." value={vendorName} onChange={(e) => setVendorName(e.target.value)} />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.name}
                </span>
              </div>
              <div className="col-xl-4">
                <label htmlFor="fill" className="form-label  fw-400 d-flex">
                  Mobile number<span className="error-text">*</span>
                </label>
                <input type="text" className="form-control rounded-3 vehicle-form-input" id="fill" placeholder="Enter here..." value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.phone_no}
                </span>
              </div>
              <div className="col-xl-4">
                <label htmlFor="fill" className="form-label  fw-400 mt-3 d-flex">
                  Mail ID<span className="error-text">*</span>
                </label>
                <input type="text" className="form-control rounded-3 vehicle-form-input" id="fill" placeholder="Enter here..." value={email} onChange={(e) => setEmail(e.target.value)} />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.email}
                </span>
              </div>
              <div className="col-xl-4">
                <label htmlFor="plate" className="form-label  fw-400 mt-3">
                  Type
                </label>
                <CommonStaticDropdown items={typeList} placeholder="Select type" value={typeOption} onSelect={handleTypeSelect} enableSearch={false} />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.type}
                </span>
              </div>
              <div className="col-xl-4 d-flex flex-column">
                <label htmlFor="fill" className="form-label  fw-400 mt-3">
                  Due date
                </label>
                <DatePicker
                  selected={dueDate}
                  onChange={(date) => setDueDate(date)}
                  dateFormat="yyyy-MM-dd"
                  customInput={
                    <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                      {dueDate ? dueDate.toLocaleDateString() : <span style={{ color: "#8790A1" }}>mm/dd/yyyy</span>}
                      <Calendar size={16} />
                    </button>
                  }
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.due_date}
                </span>
              </div>
              <div className="col-xl-4">
                <label htmlFor="plate" className="form-label  fw-400 mt-3">
                  Country
                </label>
                <CommonDropdown apiUrl={`${adminUrl}get_country`} placeholder="Select country" value={countryOption} onSelect={handleSelectCountry} />

                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.country_id}
                </span>
              </div>
              <div className="col-xl-4">
                <label htmlFor="plate" className="form-label  fw-400">
                  State
                </label>
                <CommonDropdown apiUrl={`${adminUrl}get_state?country_id=${countryOption != null ? countryOption.value : ""}`} placeholder="Select state" value={stateOption} onSelect={handleSelectState} />

                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.state_id}
                </span>
              </div>
              <div className="col-xl-4">
                <label htmlFor="plate" className="form-label  fw-400">
                  City
                </label>
                <CommonDropdown apiUrl={`${adminUrl}get_city?state_id=${stateOption != null ? stateOption.value : ""}`} placeholder="Select city" value={cityOption} onSelect={handleSelectCity} />

                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.city_id}
                </span>
              </div>
              <div className="col-xl-4">
                <label htmlFor="fill" className="form-label  fw-400">
                  ZIP code
                </label>
                <input type="text" className="form-control rounded-3 vehicle-form-input" id="fill" placeholder="Enter here..." value={zipCode} onChange={(e) => setZipCode(e.target.value)} />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.zipcode}
                </span>
              </div>
              <div className="col-xl-8">
                <label htmlFor="fill" className="form-label  fw-400 ">
                  Address
                </label>
                <input type="text" className="form-control rounded-3 vehicle-form-input" id="fill" placeholder="Enter here..." value={address} onChange={(e) => setAddress(e.target.value)} />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.address}
                </span>
              </div>
              <div className="col-xl-8">
                <label htmlFor="fill" className="form-label  fw-400 mt-3">
                  Description
                </label>
                <input type="text" className="form-control rounded-3 vehicle-form-input" id="fill" placeholder="Enter here..." value={description} onChange={(e) => setDescription(e.target.value)} />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.description}
                </span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-4 p-3 mt-3">
            <p>Location</p>
            {isLoaded && (
              <GoogleMap mapContainerStyle={{ width: "100%", height: 400 }} center={center} zoom={14} onClick={onMapClick}>
                {marker && <Marker position={marker} />}
              </GoogleMap>
            )}
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};
